import { Separator } from "@jti/core-components/components/Separator";

import styles from "./renderListSeparator.module.scss";

export const renderListSeparator = (listLength: number, listElementNumber: number) => {
  return listElementNumber < listLength - 1 ? (
    <div className={styles.separator}>
      <Separator />
    </div>
  ) : null;
};
